// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid .row {
  min-height: 50px;
}
.grid .row.header-row .edit-icon, .grid .row.footer-row .edit-icon {
  color: white !important;
}
.grid .row.header-row .row-cell, .grid .row.footer-row .row-cell {
  background-color: #AA488D;
  color: white;
  font-weight: bold;
}
.grid .row.last-row {
  border-bottom: 1px solid #cecece;
}
.grid .row.odd .row-cell {
  background-color: white;
}
.grid .row.even .row-cell {
  background-color: #FFE1F0;
}
.grid .row .row-cell {
  padding: 15px;
  position: relative;
}
.grid .row .row-cell .edit-icon {
  position: absolute;
  right: 0;
  top: 0;
  display: none;
  color: #7e7e7e;
}
.grid .row .row-cell:hover .edit-icon {
  display: block;
}
.grid .row .row-cell.inactive-cell {
  background-color: #eee;
}
.grid .row .row-cell.inactive-cell .edit-icon {
  color: #7e7e7e !important;
}
.grid .row .row-cell:not(:first-child) {
  border-top: 1px solid #cecece;
  border-right: 1px solid #cecece;
}
.grid .row .row-cell:first-child {
  border-left: 1px solid #cecece;
  border-top: 1px solid #cecece;
  border-right: 1px solid #cecece;
}
.grid .grid-logo-container img {
  width: 70px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/misc/grid/grid.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAGY;EACI,uBAAA;AADhB;AAGY;EACI,yBAAA;EACA,YAAA;EACA,iBAAA;AADhB;AAIQ;EACI,gCAAA;AAFZ;AAKY;EACI,uBAAA;AAHhB;AAQY;EACI,yBAAA;AANhB;AASQ;EACI,aAAA;EACA,kBAAA;AAPZ;AASY;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,cAAA;AAPhB;AAWgB;EACI,cAAA;AATpB;AAYY;EACI,sBAAA;AAVhB;AAWgB;EACI,yBAAA;AATpB;AAaQ;EACI,6BAAA;EACA,+BAAA;AAXZ;AAaQ;EACI,8BAAA;EACA,6BAAA;EACA,+BAAA;AAXZ;AAgBQ;EACE,WAAA;AAdV","sourcesContent":[".grid {\n    .row {\n        min-height: 50px;\n        &.header-row,\n        &.footer-row {\n            .edit-icon {\n                color: white!important;\n            }\n            .row-cell {\n                background-color: #AA488D;\n                color: white;\n                font-weight: bold;\n            }\n        }\n        &.last-row {\n            border-bottom: 1px solid    #cecece;\n        }\n        &.odd {\n            .row-cell{\n                background-color: white;\n            }\n        }\n    \n        &.even {\n            .row-cell {\n                background-color: #FFE1F0;\n            }\n        }\n        .row-cell {\n            padding: 15px;\n            position: relative;\n\n            .edit-icon {\n                position: absolute;\n                right: 0;\n                top: 0;\n                display: none;\n                color: #7e7e7e\n            }\n\n            &:hover {\n                .edit-icon {\n                    display: block;\n                }\n            }\n            &.inactive-cell {\n                background-color: #eee;\n                .edit-icon {\n                    color: #7e7e7e!important;\n                }\n            }\n        }\n        .row-cell:not(:first-child) {\n            border-top: 1px solid    #cecece;\n            border-right: 1px solid    #cecece;\n        }\n        .row-cell:first-child{\n            border-left: 1px solid #cecece;\n            border-top: 1px solid    #cecece;\n            border-right: 1px solid    #cecece;\n        }\n    }\n\n    .grid-logo-container {\n        img {\n          width: 70px;\n        }\n      }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
